import { useCancelStudyMutation, useDeleteStudyMutation } from 'services/api/studies';
import useStudyActions, {
  StudyActionsOptions,
  StudyActionTarget,
} from 'components/Flux/shared/useStudyActions';

// Flux Upload: rotas previvaz-arquivo/delete + flux/kill-process, lista com a tag 'Study'
export default function useStudyRowActions(
  study: StudyActionTarget,
  options: StudyActionsOptions = {},
) {
  const [triggerDelete, { isLoading: deleting }] = useDeleteStudyMutation();
  const [triggerCancel, { isLoading: cancelling }] = useCancelStudyMutation();

  return useStudyActions(study, {
    triggerDelete, deleting, triggerCancel, cancelling, tag: 'Study', ...options,
  });
}
